export default __webpack_public_path__ + "static/media/master-card.c70d4b0e.svg";